import { __awaiter, __generator } from "tslib";
import { fetchGet } from "../../common/http/fetch-get";
import { getStoreSupportApiConfig } from "./config/actions";
export var fetchFAQs = function (categoryKey) { return __awaiter(void 0, void 0, void 0, function () {
    var config, baseUrl, url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                config = getStoreSupportApiConfig();
                baseUrl = config.baseUrl + "/v1/" + config.siteContext + "/frequentlyaskedquestions/categories/" + categoryKey;
                url = baseUrl + "?marketLocale=" + config.marketLocale;
                return [4 /*yield*/, fetchGet(url)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
